<template>
    <app-layout v-if="loading === false">
        <bax-header-banner :user="this.$store.state.auth.user" :orderStep="isTPN() ? 2 : 3" :order="orderInfo"/>
        <main>
            <div class="bax-section bax-select-patient-wrap">
                <div class="container">
                    <order-summary
                        theme="dark"
                        ref="orderSummary"
                    ></order-summary>

                    <vue-alert v-if="!isTPN()">
                        <p>Adding drugs for:
                            <strong v-if="selectedPatient.firstName">
                                {{ selectedPatient.firstName }} {{ selectedPatient.lastName }}
                            </strong>
                            <strong v-else>--</strong>
                        </p>
                        <p class="ml-auto mt-3 mt-md-0">
                            Patient ID (MRN):
                            <strong v-if="generalPatientID">
                                {{ generalPatientID }}
                            </strong>
                            <strong v-else>--</strong>
                        </p>
                    </vue-alert>

                    <div>
                        <order-drug-form :patient="selectedPatient" :drug="editDrug" :edit="true" @refreshOrderInfo="refreshOrderInfo"></order-drug-form>
                    </div>

                    <div class="bax-cta-block cancel-modal-buttons ">
                      <a href="#"
                         class="bax-btn bax-btn-orange mt-3 mt-md-0"
                         @click.prevent="goBack" v-if="!isTPN()"
                      > Cancel editing drug </a>
                      <a href="#"
                         class="bax-btn bax-btn-orange mt-3 mt-md-0"
                         @click.prevent="goBack" v-if="isTPN()"
                      > Cancel editing product </a>
                    </div>
                </div>
            </div>
        </main>
    </app-layout>
</template>

<script>
import moment from 'moment';
import AppLayout from '@/components/layout/AppLayout.vue';
import OrderSummary from '@/components/order/OrderSummary/OrderSummary.vue';
import OrderService from '@/core/api/order/order.service';
import OrderDrugForm from '@/components/order/OrderDrug/OrderDrugForm.vue';
import { scrollPageToTop } from '@/core/helpers';
import BaxHeaderBanner from '@/components/layout/BaxHeaderBanner.vue';
import tpnMixin from '@/mixins/tpnMixin';

export default {
    name: 'OrderDrugEdit',
    mixins: [tpnMixin],
    components: {
        AppLayout,
        OrderSummary,
        OrderDrugForm,
        BaxHeaderBanner,
    },
    data() {
        return {
            loading: true,
            orderInfo: false,
            selectedPatient: {},
            editDrug: {},
        };
    },
    computed: {
        generalPatientID() {
            if (this.selectedPatient?.patientId !== '') {
                if (this.selectedPatient?.patientId?.search(/\*\d+\*/) === -1) {
                    return this.selectedPatient.patientId;
                }
                return '';
            }
            return '';
        },
    },
    methods: {
        refreshOrderInfo() {
            this.$refs.orderSummary.getOrderInfo();
        },
        goBack() {
            const { from } = this.$route.query;

            if (from === '' || typeof from === 'undefined') {
                this.$router.push({
                    name: 'home',
                });
            }

            if (from === 'drugDetail') {
                if (this.$route.query.patient_id !== 0) {
                    this.$router.push({
                        name: from,
                        params: {
                            patient: this.$route.query.patient_id,
                        },
                    });
                } else {
                    this.$router.push({
                        name: from,
                    });
                }
            }

            if (from === 'reviewComplete' || from === 'reviewCompleteTPN') {
                if (this.$route.query.patient_id !== 0) {
                    this.$router.push({
                        name: from,
                        query: {
                            patient: this.$route.query.patient_id,
                        },
                    });
                } else {
                    this.$router.push({
                        name: from,
                    });
                }
            }
        },
    },
    async created() {
        scrollPageToTop();

        this.loading = true;
        this.orderInfo = await OrderService.orderInfo(this.$route.params.orderId, false, true);
        const patient = this.orderInfo.patients.find((p) => p.patientId === this.$route.query.patient_id);
        if (typeof patient !== 'undefined') {
            this.selectedPatient = patient;
        }

        /* eslint-disable */
        let drug = null;

        // eslint-disable-next-line
        if (this.$route.query.patient_id != 0) {
            this.orderInfo.patients.forEach((p) => {
                if (p.patientId === this.$route.query.patient_id) {
                    p.drugs.forEach((drugt) => {
                        if (drugt.orderLineItemId === this.$route.query.drug) {
                            drug = drugt;
                        }
                    });
                }
            });
        } else {
            const tt = this.orderInfo.patients.find((p) => p.patientId === '');
            tt?.drugs.forEach((d) => {
                if (d.orderLineItemId === this.$route.query.drug) {
                    drug = d;
                }
            })
        }

        let treatmentDate = '';

        if (typeof drug?.treatmentDate !== 'undefined' && drug?.treatmentDate !== '') {
            if (moment(drug.treatmentDate, 'DD/MM/YYYY', true).isValid() === false) {
                treatmentDate =  moment(drug.treatmentDate).format('DD/MM/YYYY');
            } else {
                treatmentDate = drug.treatmentDate;
            }
        }
      if (drug?.type === 'TPN') {
        this.editDrug = {
          drugOne: {
            title: drug.tpn_product,
            type: 'TPN',
            tpn_code: drug.tpn_code,
            tpn_product: drug.tpn_product,
            min_order_quantity: drug.min_order_quantity,
            max_batch_size: drug.max_batch_size,
            accept_multiple: drug.multiple,
          },
          quantity: drug.quantity,
          oldDrugPresentationId: drug.tpn_code,
          orderLineItemId: drug.orderLineItemId,
          treatmentDate: treatmentDate,
          isFavourite: drug.isFavourite,
        };
      } else if (drug?.type === 'FP') {
            this.editDrug = {
                drugOne: {
                    title: drug.drug1GenericName,
                    type: 'FP',
                    finish_product_code: drug.fp_code,
                    min_order_quantity: drug.min_order_quantity,
                    max_batch_size: drug.max_batch_size,
                    description: drug.description,
                    accept_multiple: drug.multiple,
                },
                quantity: drug.quantity,
                oldDrugPresentationId: drug.finishedProductCode,
                orderLineItemId: drug.orderLineItemId,
                treatmentDate: treatmentDate,
                isFavourite: drug.isFavourite,
                // drug1_name: drug.drug1GenericName,
                // finishedProductCode: drug.finishedProductCode,
                // type: drug.type,
                // orderLineItemId: drug.orderLineItemId,
                // adminRouteCode: drug.administrationRouteDescription,
                // containerTypeId: drug.containerType,
                // diluent_id: drug.diluentGenericName,
                // infusionTime: drug.infusionTime,
                // containerId: drug.containerPartCode || '',
                // ancillary1Id: drug.ancillary1GenericName,
                // ancillary2Id: drug.ancillary2GenericName,
            };
        } else if (drug) {
            this.editDrug = {
                drugOne: {
                    title: drug?.drug1_name,
                    type: 'PS',
                },
                drugPresentationId: drug.drugPresentationId,
                quantity: drug.quantity,
                drug1_name: drug.drug1_name,
                drug1_dose: drug.drug1Dose,
                drug1_maxdose: drug.drug1_maxdose,
                drug1_maxdose_uom: drug.drug1_maxdose_uom,
                adminRouteCode: drug.adminRouteCode,
                containerTypeId: drug.containerTypeId,
                diluent_id: drug.diluent_id,
                infusionTime: drug.infusionTime || '',
                infusionTimeDuration: drug.infusionTimeDuration || '',
                containerId: drug.containerPartCode ||  drug.containerId || '',
                diluentVolume: drug.diluentVolume,
                diluentExactFinalVolume: drug.diluentExactFinalVolume,
                ancillary1Id: drug.ancillary1Id,
                ancillary2Id: drug.ancillary2Id,
                treatmentDate: treatmentDate,
                onHold: drug.onHold,
                drug2_id: drug.drug2_id,
                drug2_dose: drug.drug2Dose,
                drug2_maxdose: drug.drug2_maxdose,
                drug2_maxdose_uom: drug.drug2_maxdose_uom,
                orderLineItemId: drug.orderLineItemId,
                isFavourite: drug.isFavourite,
            };

        }
        if (drug?.deliveryDateArray) {
            this.editDrug.deliveryDateArray = drug.deliveryDateArray;
        }
        this.loading = false;
    },
};
</script>
